import React from 'react';
import RootSvg, { RootSvgProps } from '@/components/icons/RootSvg';

export default function SvgElectric(props: RootSvgProps) {
  return (
    <RootSvg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g clipPath="url(#clip0_2552_9698)">
        <path
          d="M14 2L11 8L17 9L7.5 18H6L9 12L3 11L12.5 2H14Z"
          fill="url(#paint0_linear_2552_9698)"
        />
      </g>
      <defs>
        <linearGradient
          id="paint0_linear_2552_9698"
          x1="10"
          y1="18"
          x2="10"
          y2="2.7"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#3F73D3" />
          <stop offset="1" stopColor="#237EA3" />
        </linearGradient>
        <clipPath id="clip0_2552_9698">
          <rect
            width="20"
            height="20"
            fill="white"
            transform="matrix(0 1 -1 0 20 0)"
          />
        </clipPath>
      </defs>
    </RootSvg>
  );
}
